import styled from 'styled-components';
import Text from 'shared/components/Text/Text';

export const TpvModalContent = styled.div`
  width: 100%;
  max-width: 306px;

  table {
    width: 100%;

    tr {
      font-weight: 500;
      td {
        padding-top: 16px;
      }
      td:last-child {
        text-align: right;
      }
    }
  }
`;

export const CardTitle = styled(Text)`
  font-weight: 500;
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
`;

export const CardText = styled(Text)`
  ${({ theme }) => `
      color: ${theme.colors.textSecondaryGrey90};
      font-weight: 200;
      line-height: 24px;
      font-size: 16px;

      &:not(:last-of-type) {
          margin-bottom: 16px;
      }
      strong {
          font-weight: 700;
      }
`}
`;

export const TpvBaseContainer = styled.div`
  ${({ theme }) => `
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: fit-content;

        svg {
            display: block;
            margin: 20px auto 26px;
        }

        @media screen and (min-width: ${theme.breakpoints.small}) {
          width: 414px;
        }
    `}
`;

export const TpvModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 24px;
  margin-top: 36px;
  width: 100%;
`;
